import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(home)/hero.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(home)/highlighted-projects.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(home)/latest-posts.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/back-button.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/counter.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/increment-counter.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/progress.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/tooltip.tsx")